'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = exports.StyleSheet = exports.StylesProvider = exports.styled = undefined;
exports.createCssClass = createCssClass;
exports.keyframes = keyframes;
exports.reset = reset;
exports.insertCss = insertCss;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _glamor = require('@rexlabs/glamor');

var _elementStyles = require('@rexlabs/element-styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.styled = _elementStyles.styled;
exports.StylesProvider = _elementStyles.StylesProvider;

// Note: Guard against incremental ID clash, with other @rexlabs/styling packages.

var MODULE_ID = new Date().valueOf();

var cssIdRegex = /data-css-([a-zA-Z0-9\-_]+)/;
function cssIdFor(rule) {
  var match = cssIdRegex.exec(rule);
  if (!match) {
    throw new Error('Not a css rule string.');
  }
  return match[1];
}

/**
 * Takes a map of CSS rules by given names, and returns a new object with
 * classNames by the given names. CSS rules are processed to classNames by glamor.
 *
 * @param {Object} cssClassesObject - CSS rules keyed by class names.
 * @returns {Object}
 */
function StyleSheet(cssClassesObject) {
  if (StyleSheet.__paused) {
    // HACK: Uses undocumented glamor to generate class name ID's:
    //  1. Converting Style Objects to a string of real CSS
    //  2. Getting the ID's from the generated CSS with regex
    //  3. Prefix the ID with "css-", and we (probably) have the class name that
    //     will be latter available from a Stylesheet flush.
    //  4. Store the real style object's away, in correct order, for later use
    var pressure = [];
    var stylesheet = _lodash2.default.mapValues(cssClassesObject, function (cssProps, key) {
      var cssRulesString = (0, _glamor.cssFor)(cssProps);
      if (!cssRulesString) return '';
      var cssId = cssIdFor(cssRulesString);
      pressure = pressure.concat(cssProps);
      return 'css-' + cssId;
    });
    StyleSheet.__pressure = (StyleSheet.__pressure || []).concat([pressure]);
    return stylesheet;
  } else {
    return _lodash2.default.mapValues(cssClassesObject, function (cssProps) {
      return createCssClass(cssProps);
    });
  }
}
StyleSheet.pause = function pauseStyleSheets() {
  StyleSheet.__paused = true;
};
StyleSheet.flush = function flushStyleSheets() {
  resetStyleSheet(function () {
    return StyleSheet.__pressure.forEach(function (sheet) {
      return StyleSheet(sheet);
    });
  });
};
StyleSheet.flushReversed = function flushReversedStyleSheets() {
  resetStyleSheet(function () {
    return StyleSheet.__pressure.reverse().forEach(function (sheet) {
      return StyleSheet(sheet);
    });
  });
};

function resetStyleSheet(cb) {
  StyleSheet.__paused = false;
  cb();
  StyleSheet.__pressure = [];
}

exports.StyleSheet = StyleSheet;


var classId = 0;
/**
 * Injects the CSS rule into the page with glamor, and returns a class name.
 *
 * Note:
 * To avoid problems later in development of apps, rulesets are forced to be
 * unique. This results in all classnames being unique, and helps avoid
 * precedence ordering issues.
 *
 * @param {Object} cssProps - CSS
 * @return {String}
 */
function createCssClass(cssProps) {
  return _lodash2.default.isPlainObject(cssProps) ? process.env.NODE_ENV === 'test' ? (0, _glamor.css)(cssProps).toString() : (0, _glamor.css)({ '@@id': MODULE_ID + '_' + classId++ }, cssProps).toString() : cssProps;
}

/**
 * Injects css keyframes into a page, returning the name of the keyframes.
 *
 * @param {String} name
 * @param {Object} frames
 * @return {String}
 */
function keyframes(name, frames) {
  return _glamor.css.keyframes(name, frames).toString();
}

/**
 * Inject meyer's css reset into a page.
 */
function reset() {
  insertCss(MYERS_RESET_CSS_RULES);
}

/**
 * Insert global css rules.
 *
 * @param cssRulesString
 */
function insertCss(cssRulesString) {
  return cssRulesString.trim().replace(/}?$/, '').split('}').map(function (x) {
    return x ? x + '}' : '';
  }).forEach(function (rule) {
    if (rule) {
      var minifiedRule = rule.replace(/\n/gm, '').replace(/\s+/g, '').trim();
      _glamor.css.insert(minifiedRule);
    }
  });
}

/*
 http://meyerweb.com/eric/tools/css/reset/
 v2.0 | 20110126
 License: none (public domain)
 */
// language=CSS
var MYERS_RESET_CSS_RULES = '\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n}\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section {\n    display: block;\n}\nbody {\n    line-height: 1;\n}\nol, ul {\n    list-style: none;\n}\nblockquote, q {\n    quotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n    content: \'\';\n    content: none;\n}\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}';

exports.styleSheet = _glamor.styleSheet;